import type { DetailsSuccess } from '@autobid/strapi-integration/typescript/auction/detailsCar'
import { CAR_PREVIEW_PDF_ID } from '@autobid/ui/constants/CAR_PREVIEW_PDF_ID'

export const CAR_PREVIEW_PDF_DATA: DetailsSuccess['data']['singleItem'] = {
  item: {
    itemData: {
      id: CAR_PREVIEW_PDF_ID,
      appId: 0,
      slug: 'audi-a3-a33-freitext-565306',
      catalogNumber: 1,
      auctionId: 0,
      price: {
        current: 20000,
        minimal: 15000,
        start: 15000,
      },
      publicationInfo: {
        status: 'PUBLISHED',
        dataHash: {
          item: 'hash',
          auction: 'hash',
        },
      },
      taxInformation: '',
      name: 'Kia Picanto 1.0 MPi Comfortplusline',
      stage: 'IN_AUCTION',
      hasBid: true,
      isWatcher: true,
      dataAddition: [
        {
          id: 1,
          categoryId: 1,
          categoryLabel: 'Taxation',
          content: 'description',
          additionTime: '2024-05-29 14:33:19+00:00',
        },
      ],
      status: {
        bank11FinancingAvailable: false,
        bmwBankFinancingAvailable: false,
        highlighted: false,
        transportAvailable: false,
        transportCrossborderAvailable: false,
      },
      supplier: {
        id: 1,
        label: 'Autobid',
        logo: null,
      },
      manufacturer: {
        name: 'Kia',
      },
      additionalInformation: {
        itemLocationCode: 'PL-83',
        itemLocationCountry: {
          isoCode: 'PL',
          name: 'Poland',
          vatRate: 23,
        },
      },
      auctionStartDate: '2024-06-05T10:00:00+00:00',
      auctionNumber: 0,
      imageGroups: {
        itemImageAdditionalDetails: [],
        itemImageBeautyDetails: [],
        itemImagePanelInstrument: [],
        itemImagesExterior: [],
        itemImagesInterior: [],
        itemImagesWindshield: [],
        itemMainImage: [],
        itemMainImageSubgroup: [],
        itemSecondWheels: [],
        itemWheels: [],
      },
      category: {
        id: 0,
        name: 'Kombi',
      },
      hasNote: false,
      equipments: {},
      isHighestBidder: false,
    },
    itemDetails: {
      headlineDescription: 'Audi A3 A33 BASTLERFAHRZEUG Freitext',
      generalDescriptionHeader: '1.6 Liter, Diesel, 6-Gang-Schaltgetriebe, Partikelfilter',
      information: [
        ['Kategorie', 'Kleinwagen, 4 türig, Allrad'],
        ['Serie', 'serie'],
        ['Motorart', 'Diesel'],
        ['Kraftstoffart', 'Diesel'],
        ['Schadstoff-Klasse', 'EURO 6'],
        ['CO2-Emission (in g/km kombiniert)', '230'],
        ['Leistung', '99 KW / 135 PS'],
        ['Erstzulassung', '12.2023'],
        ['Produktionsdatum', '12.2018'],
        ['KBA-Schlüssel Hersteller', 'HERS'],
        ['KBA-Schlüssel Typ', 'TYP'],
        ['Fahrzeug-Identifikations-Nummer', 'JA3AH86D94U061625'],
        ['Getriebeart', '6-Gang-Schaltgetriebe'],
        ['Zulässiges Gesamtgewicht (in kg)', '1000'],
        ['Farbe', 'gelb Metallic'],
        ['Farbbezeichnung', 'Einparkhilfe (0938)'],
        ['Tacho abgelesen', '37800 Kilometer'],
        ['Gesamtlaufleistung gemäß Vorbesitzer', '100000 Kilometer'],
        ['Gesamtanzahl bekannter Halter', '9 Halter'],
        ['Fahrzeugherkunft', 'Flottenfahrzeug, Mietwagen'],
        ['Standort', 'PL-83'],
      ],
      documents: [
        [
          'Versand Fahrzeugdokumente',
          'Der Versand des/der Eigentumsnachweis erfolgt frühestens 30 Werktag(e) nach Zahlungseingang.',
        ],
        ['Handling Fahrzeugdokumente', '15.00 Euro netto'],
        ['Anzahl Schlüssel', '2'],
        [
          'Angaben Kundendienst',
          'Scheckheft liegt vor., Service fällig, Ölservice überzogen - Eingeschränkte Gewährleistung.',
        ],
        ['Letzte Inspektion', '02.2024'],
        ['Zahnriemenwechsel bei', '10000 Kilometer'],
        ['Hauptuntersuchung bis', '09.2022, Tuv nach §21 fallig, Tuv-Bericht'],
        ['Abgasuntersuchung bis', '10.2027, AU-Bericht liegt vor'],
        [
          'pdf de title',
          'https://cdn.t2.amab.dev/content/app/cars/5654/565306/pdf_file_i.pdf',
        ],
      ],
      extras: [
        [
          'ABS',
          'Airbags: 9',
          'Alarmanlage',
          'Anhängerkupplung fest montiert',
          'Außenspiegel manuell verstellbar',
          'Auto Hold',
          'Automatisch abblendender Außenspiegel',
          'Automatisch abblendender Innenspiegel',
          'Automatische Heckklappe',
          'Beheizbarer Außenspiegel',
          'Blendfreies Fernlicht',
          'Bordcomputer',
          'CD-Wechsler',
          'Dachreling',
          'Einparkhilfe Einparkhilfe vorne/hinten',
          'El. Ausstellfenster hi.',
          'Elektr. Heckrollo',
          'elektrische Fensterheber vorne',
          'Fahrwerksprogramm ASC',
          'Fernlichtassistent',
          'Fond Entertainment',
          'Fondscheiben abgedunkelt',
          'Head-up Display',
          'Hill Descent Control HDC',
          'Induktionslader für Smartphones',
          'Innenverkleidung: Stoff, Leder, Kunstleder',
          'Keyless-Go',
          'Klima auch im Fond',
          'Kurvenlicht',
          'Kühlfach in Mittelarmlehne hinten',
          'LED-Scheinwerfer',
          'Leder- / Holzlenkrad',
          'Lederlenkrad',
          'Lenkrad heizbar',
          'Multifunktionslenkrad',
          'Navi mit Kartendarstellung: Navi',
          'Nebelscheinwerfer',
          'Niveauregulierung',
          'Panoramadach, feststehend',
          'Parkassistent',
          'Partikelfilter',
          'Radio, DAB',
          'Regensensor',
          'Reifen Pannen Anzeige RPA',
          'Rückfahrkamera',
          'Schaltfunktion Lenkrad',
          'Servolenkung',
          'Servoschließung (Türen, Heckdeckel)',
          'Sonnenschutzrollo Fondtüren',
          'Soundsystem',
          'Sportfahrwerk',
          'Spracheingabesystem',
          'Spurhalteassistent',
          'Spurwechselassistent',
          'Standheizung',
          'Start/stop System',
          'Telefon: Vorbereitung mit Freisprecheinrichtung',
          'Tempomat',
          'Touchscreen',
          'TV',
          'Windschott',
          'Windschutzscheibe heizbar',
          'Zentralverriegelung mit Fernbedienung',
          'Nr. Beschreibung',
          '01CB CO2 Umfang',
          '01CX XtraBoost',
          '01DF Abgastechnik EU6d/e',
          '01R3 18 M LMR Doppelspeiche 848 M Bicolor / MB',
          '0230 EU-spezifische Zusatzumfaenge',
          '02PA Radschraubensicherung',
          '02TB Steptronic Sport Getriebe',
          '02VB Reifendruckanzeige',
          '02VF Adaptives M Fahrwerk',
          '02VL Variable Sportlenkung',
          '0302 Alarmanlage',
          '0322 Komfortzugang',
          '0337 M Sportpaket',
          '03AC Anhaengerkupplung',
          '03KA Akustikverglasung',
          '03MC BMW Individual Dachreling Hochglanz Shadow Line',
          '0418 Gepaeckraumpaket',
          '0420 Sonnenschutzverglasung',
          '0428 Warndreieck',
          '0430 Innen- und Außenspiegelpaket',
          '0431 Innenspiegel, automatisch abblendend',
          '0481 Sportsitze fuer Fahrer und Beifahrer',
          '0493 Ablagenpaket',
          '0494 Sitzheizung fuer Fahrer und Beifahrer',
          '04AW Instrumententafel in Sensatec',
          '04LN M Interieurleisten Aluminium Rhombicle Anthrazit',
          '04NE Blow by-Heizer',
          '04T3 Flexible Fast Charger (Mode 2)',
          '04T4 Ladekabel (Mode 3) für öffentliches Laden',
          '04U9 Akustischer Fußgängerschutz',
          '04UR Ambientes Licht',
          '0534 Klimaautomatik',
          '0548 Kilometertacho',
          '0552 Adaptiver LED-Scheinwerfer',
          '05AC Fernlichtassistent',
          '05AQ Active Guard Plus',
          '05AS Driving Assistant',
          '05DA Beifahrerairbag-Deaktivierung',
          '05DC Fondkopfstützen, klappbar',
          '05DF Aktive Geschwindigkeitsregelung mit Stop&Go-Funktion',
          '05DM Parking Assistant',
          '0654 DAB-Tuner',
          '0676 HiFi Lautsprechersystem',
          '06AE Teleservices',
          '06AF Gesetzlicher Notruf',
          '06AK ConnectedDrive Services',
          '06C4 Connected Package Professional',
          '06NX Ablage für Wireless Charging',
          '06U3 BMW Live Cockpit Professional',
          '06VB Steuerung Infotainment',
          '0710 M Lederlenkrad',
          '0715 M Aerodynamikpaket',
          '0760 BMW Individual Hochglanz Shadow Line',
          '0775 M Dachhimmel anthrazit',
          '07M9 M Hochglanz Shadow Line mit erweiterten Umfängen',
          '07R7 Innovationspaket',
          '0801 Deutschland-Ausfuehrung',
          '0851 Sprachversion Deutsch',
          '0879 Deutsch / Bordliteratur',
          '08KA Ölwartungsintervall 24 Monate/30.000 km',
          '08R9 Kältemittel',
          '08TF Aktiver Fußgängerschutz',
          '08WM Steuerung D',
          '08WQ Steuerung G"',
        ],
        [],
        { vanmossel_header: null },
      ],
      specialExtras: {
        extras: [
          '"Easy Open"-Paket',
          'Ablage-Paket',
          'Abstandswarnung',
          'Active Info Display',
          'Active Lighting System',
          'Adaptive  Fahrwerksregelung DCC',
          'Adaptive air suspension',
          'Adaptive light - dynamisches Kurvenlicht',
          'Advanced key (Audi)',
          'Ambiente-Paket',
          'Ambientebeleuchtung',
          'Assistenz Paket',
          'Audi Braking Guard',
          'Audi connect',
          'Audi drive Select',
          'AUDI magnetic ride',
          'AUDI music interface',
          'Audi pre sense',
          'Audi smartphone interface',
          'Auto-Hold-Funktion',
          'Bang & Olufsen Sound System',
          'Berganfahrassistent',
          'BOSE Surround Sound',
          'Business-Paket',
          'Chrom Paket I',
          'Connectivity Paket',
          'Cool & Find',
          'Cool & Sound',
          'Dachhimmel schwarz',
          'Digital-Voice-Enhancement (DVE)',
          'Dynaudio Sound System',
          'Dämmglas',
          'Dämpferregelung',
          'Effizienzassistent',
          'Elektrik-Paket I',
          'elektrische Schiebetür links',
          'elektrische Schiebetür rechts',
          'Elektrisches Aufstelldach',
          'Exterieur-Paket',
          'Fahrerassistenz Paket',
          'Fahrerassistenz Paket Plus',
          'Family-Paket',
          'Garagentoröffner',
          'Gepäckraum Paket',
          'Geschwindigkeitsregelanlage, adaptiv (ACC)',
          'Keramikbremsanlage',
          'KESSY (Keyless-Go-VW)',
          'Keyless Access',
          'Komfortschlüssel',
          'Lane Assist',
          'Licht & Sicht Paket',
          'Licht-Paket',
          'Luftfederung',
          'Luftstandheizung',
          'Manuelles Aufstelldach',
          'Multimediabuchse  AUX/Media-IN',
          'Müdigkeitserkennung',
          'Nachtsichtassistent',
          'Off Road-Paket I',
          'Optik-Paket',
          'Parklenkassistent "Park  Assist"',
          'Pausenempfehlung',
          'Professional-Paket',
          'Protection-Paket',
          'R-Line "Exterieur"',
          'R-Line "Interieur"',
          'R-Line "Plus"',
          'R-Line Sport Paket',
          'S-Line Exterieurpaket',
          'S-Line selection Paket',
          'S-Line selection plus Paket',
          'S-Line Sportfahrwerk',
          'S-Line Sportpaket',
          'Schlechtwegefahrwerk',
          'Sicht-Paket',
          'Side Assist (Spurwechselassistent)',
          'Soundsystem  "Volkswagen Sound"',
          'Spiegel-Paket',
          'Sportpaket',
          'Sprachdialogsystem',
          'Stauassistent',
          'Tempowarnung',
          'Top Paket',
          'Umgebungsansicht "Area View"',
          'Umgebungskameras',
          'USB-Schnittstelle',
          'Verkehrszeichenerkennung',
          'Virtual Cockpit',
          'Winter-Paket',
          'Zuheizer',
        ],
      },
      seats: {
        list: [
          'Anzahl Sitze 4',
          'Dinamica, Velours: orange, orange (Black, Muster)',
          'Lorem ipsum dolor sit amet',
          'Sportsitze',
          'Mittelarmlehne: vorne und hinten',
          'geteilte Rückbank',
          'integrierte Kindersitze im Fond',
          'Durchlademöglichkeit',
          'Skisack',
        ],
        table: {
          tableHeadings: [
            '',
            'Fahrersitz',
            'Beifahrer',
            'Fond links',
            'Fond rechts',
          ],
          tableCells: [
            ['Sitzheizung', true, false, false, false],
            ['Mit Memory-Funktion', false, false, true, false],
            ['Sitzlüftung', false, true, false, false],
            ['Lordosenstütze', false, true, false, false],
            ['Mit Massage-Funktion', false, false, false, true],
            ['Multikontursitz', false, false, false, true],
            ['Fahrdynamische Sitze', false, true, false, false],
          ],
        },
      },

      mainImageSubgroup: [
        {
          id: 787036,
          imageType: 'general',
          category: 1,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht vorne links',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/787036_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 787037,
          imageType: 'general',
          category: 2,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht vorne rechts',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/787037_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 787038,
          imageType: 'general',
          category: 3,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht hinten links',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/787038_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 787039,
          imageType: 'general',
          category: 4,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht hinten rechts',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/787039_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785947,
          imageType: 'general',
          category: 5,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Innenraum',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785947_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
      ],
      imagePanelInstrument: {
        images: [
          {
            id: 785949,
            imageType: 'general',
            category: 7,
            description: {
              type: 'categoryLabel',
              categoryLabel: 'Ansicht Kombiinstrument',
              defects: [],
            },
            line: 0,
            links: {
              hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785949_hd.jpg',
              l: '',
              m: '',
              s: '',
              xs: '',
            },
          },
        ],
        list: ['Fehlermeldung Kombiinstrument'],
      },
      imageAdditionalDetails: [
        {
          id: 785950,
          imageType: 'general',
          category: 117,
          description: {
            type: 'categoryLabel',
            categoryLabel: '2ter Radsatz',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785950_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785951,
          imageType: 'general',
          category: 117,
          description: {
            type: 'categoryLabel',
            categoryLabel: '2ter Radsatz',
            defects: [],
          },
          line: 1,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785951_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785952,
          imageType: 'general',
          category: 102,
          description: {
            type: 'dedicated',
            categoryLabel: 'Zusatzbild',
            dedicated: { de: 'Übertragung', en: 'transmission' },
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785952_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785953,
          imageType: 'general',
          category: 102,
          description: {
            type: 'dedicated',
            categoryLabel: 'Zusatzbild',
            dedicated: { de: 'Stamm', en: 'tribe' },
            defects: [],
          },
          line: 1,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785953_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
      ],
      imageBeautyDetails: [
        {
          id: 785956,
          imageType: 'general',
          category: 200,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Front',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785956_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785957,
          imageType: 'general',
          category: 201,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Heck',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785957_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785958,
          imageType: 'general',
          category: 202,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Kofferraum / Laderaum',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785958_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785959,
          imageType: 'general',
          category: 208,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Scheinwerfer links',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785959_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785960,
          imageType: 'general',
          category: 213,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Lenkrad',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785960_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785961,
          imageType: 'general',
          category: 214,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Mittelkonsole',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785961_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785962,
          imageType: 'general',
          category: 214,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Mittelkonsole',
            defects: [],
          },
          line: 1,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785962_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785963,
          imageType: 'general',
          category: 215,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Navigation',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785963_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785964,
          imageType: 'general',
          category: 216,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Weitere Sonderausstattung',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785964_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785965,
          imageType: 'general',
          category: 217,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Sitze vorne',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785965_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785966,
          imageType: 'general',
          category: 218,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Bedienknöpfe eSitze',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785966_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785967,
          imageType: 'general',
          category: 226,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Soundsystem',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785967_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785968,
          imageType: 'general',
          category: 227,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Rückbank',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785968_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785969,
          imageType: 'general',
          category: 228,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Bedienknöpfe eSitze hinten',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785969_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785970,
          imageType: 'general',
          category: 219,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Klimaautomatik Fond',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785970_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785971,
          imageType: 'general',
          category: 220,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Fondentertainment und Zubehör',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785971_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785972,
          imageType: 'general',
          category: 221,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht 3. Sitzreihe',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785972_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785973,
          imageType: 'general',
          category: 222,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht LPG Umbau',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785973_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785974,
          imageType: 'general',
          category: 223,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Elektrofahrzeug',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785974_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785975,
          imageType: 'general',
          category: 224,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Windschott',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785975_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785954,
          imageType: 'general',
          category: 103,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Detailfoto',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785954_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785955,
          imageType: 'general',
          category: 103,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Detailfoto',
            defects: [],
          },
          line: 1,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785955_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
      ],
      demurrageFee: ['2024-08-30T11:55:00.000+02:00', '3,00 EUR'],
      wheels: {
        list: [
          ['Reifenart', 'Run-Flat, Winterreifen'],
          ['Leichtmetallfelgen', '14 Zoll'],
          ['Felgengröße Vorderachse', '8G x 14 ET 100'],
          ['Felgengröße Hinterachse', '6G x 14 ET 100'],
          ['Geschwindigkeitsindex', 'S 180 km/h \n'],
          ['Lochkreis', '1x11 mm'],
        ],
        tables: [
          {
            title: 'Reifen',
            table: {
              tableHeadings: [
                '',
                'Profiltiefe',
                'Dimension',
                'LI',
                'DOT',
                'porös',
                'gerissen',
                'ohne Luft',
              ],
              tableCells: [
                [
                  'vorne links',
                  '3 mm',
                  '165/50/14',
                  '100',
                  '22',
                  false,
                  true,
                  false,
                ],
                [
                  'hinten links',
                  '>3 mm',
                  '165/70/14',
                  '100',
                  '222',
                  false,
                  false,
                  true,
                ],
                [
                  'hinten links',
                  '>3 mm',
                  '165/70/14',
                  '100',
                  '222',
                  false,
                  true,
                  false,
                ],
                [
                  'hinten links',
                  '>3 mm',
                  '165/70/14',
                  '100',
                  '222',
                  false,
                  true,
                  false,
                ],
                [
                  'hinten rechts',
                  '9 mm',
                  '165/70/14',
                  '100',
                  '22',
                  true,
                  false,
                  true,
                ],
                [
                  'vorne rechts',
                  '1 mm',
                  '165/50/14',
                  '100',
                  '22',
                  true,
                  true,
                  true,
                ],
                [
                  'vorne rechts',
                  '1 mm',
                  '165/50/14',
                  '100',
                  '22',
                  false,
                  false,
                  false,
                ],
              ],
            },
          },
          {
            title: 'Felgen',
            table: {
              tableHeadings: ['beschädigt', 'Kratzer'],
              tableCells: [
                [true, false],
                [false, true],
                [false, false],
                [false, false],
                [false, false],
                [true, true],
                [false, false],
              ],
            },
          },
          {
            title: 'Radkappen',
            table: {
              tableHeadings: ['beschädigt', 'fehlt', ''],
              tableCells: [
                [
                  false,
                  false,
                  {
                    id: 786015,
                    imageType: 'defect',
                    category: 28,
                    description: {
                      type: 'defects',
                      categoryLabel: 'vorne links',
                      defects: [
                        { id: 10, name: 'Beschadigt' },
                        { id: 17, name: 'Gerissen' },
                      ],
                    },
                    line: 0,
                    links: {
                      hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786015_hd.jpg',
                      l: '',
                      m: '',
                      s: '',
                      xs: '',
                    },
                  },
                ],
                [
                  false,
                  false,
                  {
                    id: 786017,
                    imageType: 'defect',
                    category: 26,
                    description: {
                      type: 'defects',
                      categoryLabel: 'hinten links',
                      defects: [
                        { id: 4, name: 'Kratzer' },
                        { id: 18, name: 'Ohne Luft' },
                      ],
                    },
                    line: 1,
                    links: {
                      hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786017_hd.jpg',
                      l: '',
                      m: '',
                      s: '',
                      xs: '',
                    },
                  },
                ],
                [
                  false,
                  false,
                  {
                    id: 786016,
                    imageType: 'defect',
                    category: 26,
                    description: {
                      type: 'defects',
                      categoryLabel: 'hinten links',
                      defects: [{ id: 17, name: 'Gerissen' }],
                    },
                    line: 0,
                    links: {
                      hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786016_hd.jpg',
                      l: '',
                      m: '',
                      s: '',
                      xs: '',
                    },
                  },
                ],
                [
                  false,
                  false,
                  {
                    id: 786018,
                    imageType: 'defect',
                    category: 26,
                    description: {
                      type: 'defects',
                      categoryLabel: 'hinten links',
                      defects: [{ id: 17, name: 'Gerissen' }],
                    },
                    line: 2,
                    links: {
                      hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786018_hd.jpg',
                      l: '',
                      m: '',
                      s: '',
                      xs: '',
                    },
                  },
                ],
                [
                  false,
                  false,
                  {
                    id: 786019,
                    imageType: 'defect',
                    category: 27,
                    description: {
                      type: 'defects',
                      categoryLabel: 'hinten rechts',
                      defects: [
                        { id: 16, name: 'Poros' },
                        { id: 18, name: 'Ohne Luft' },
                      ],
                    },
                    line: 0,
                    links: {
                      hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786019_hd.jpg',
                      l: '',
                      m: '',
                      s: '',
                      xs: '',
                    },
                  },
                ],
                [
                  false,
                  false,
                  {
                    id: 786020,
                    imageType: 'defect',
                    category: 29,
                    description: {
                      type: 'defects',
                      categoryLabel: 'vorne rechts',
                      defects: [
                        { id: 4, name: 'Kratzer' },
                        { id: 10, name: 'Beschadigt' },
                        { id: 16, name: 'Poros' },
                        { id: 17, name: 'Gerissen' },
                        { id: 18, name: 'Ohne Luft' },
                      ],
                    },
                    line: 0,
                    links: {
                      hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786020_hd.jpg',
                      l: '',
                      m: '',
                      s: '',
                      xs: '',
                    },
                  },
                ],
                [
                  false,
                  false,
                  {
                    id: 786021,
                    imageType: 'defect',
                    category: 29,
                    description: {
                      type: 'defects',
                      categoryLabel: 'vorne rechts',
                      defects: [],
                    },
                    line: 1,
                    links: {
                      hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786021_hd.jpg',
                      l: '',
                      m: '',
                      s: '',
                      xs: '',
                    },
                  },
                ],
              ],
            },
          },
        ],
        images: [
          {
            id: 786026,
            imageType: 'general',
            category: 128,
            description: {
              type: 'categoryLabel',
              categoryLabel: '',
              defects: [],
            },
            line: 0,
            links: {
              hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786026_hd.jpg',
              l: '',
              m: '',
              s: '',
              xs: '',
            },
          },
        ],
      },
      secondWheels: {
        list: [
          ['Räder', 'Run-Flat, Winterreifen'],
          ['Leichtmetallfelgen', '15 Zoll'],
          ['Felgengröße Vorderachse', '7G x 15 ET 200'],
          ['Felgengröße Hinterachse', '6F x 15 ET 200'],
          ['Geschwindigkeitsindex', 'Q 160 km/h'],
          ['Lochkreis', '2x222 mm'],
        ],
        tables: [
          {
            title: 'Reifen',
            table: {
              tableHeadings: [
                '',
                'Profiltiefe',
                'Dimension',
                'LI',
                'DOT',
                'porös',
                'gerissen',
                'ohne Luft',
              ],
              tableCells: [
                [
                  'vorne links',
                  '4 mm',
                  '195/55/15',
                  '100',
                  '22',
                  false,
                  false,
                  true,
                ],
                [
                  'hinten links',
                  '4 mm',
                  '195/55/15',
                  '100',
                  '22',
                  false,
                  false,
                  false,
                ],
                [
                  'hinten rechts',
                  '7 mm',
                  '195/55/15',
                  '100',
                  '22',
                  true,
                  false,
                  false,
                ],
                [
                  'vorne rechts',
                  '3 mm',
                  '195/55/15',
                  '100',
                  '22',
                  false,
                  false,
                  true,
                ],
              ],
            },
          },
          {
            title: 'Felgen',
            table: {
              tableHeadings: ['beschädigt', 'Kratzer'],
              tableCells: [
                [false, false],
                [false, false],
                [false, true],
                [true, false],
              ],
            },
          },
          {
            title: 'Radkappen',
            table: {
              tableHeadings: ['beschädigt', 'fehlt', ''],
              tableCells: [
                [
                  false,
                  false,
                  {
                    id: 786022,
                    imageType: 'defect',
                    category: 70,
                    description: {
                      type: 'defects',
                      categoryLabel: 'vorne links',
                      defects: [{ id: 18, name: 'Ohne Luft' }],
                    },
                    line: 0,
                    links: {
                      hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786022_hd.jpg',
                      l: '',
                      m: '',
                      s: '',
                      xs: '',
                    },
                  },
                ],
                [false, false, null],
                [
                  false,
                  false,
                  {
                    id: 786023,
                    imageType: 'defect',
                    category: 69,
                    description: {
                      type: 'defects',
                      categoryLabel: 'hinten rechts',
                      defects: [
                        { id: 4, name: 'Kratzer' },
                        { id: 16, name: 'Poros' },
                      ],
                    },
                    line: 0,
                    links: {
                      hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786023_hd.jpg',
                      l: '',
                      m: '',
                      s: '',
                      xs: '',
                    },
                  },
                ],
                [
                  false,
                  false,
                  {
                    id: 786024,
                    imageType: 'defect',
                    category: 71,
                    description: {
                      type: 'defects',
                      categoryLabel: 'vorne rechts',
                      defects: [
                        { id: 10, name: 'Beschadigt' },
                        { id: 18, name: 'Ohne Luft' },
                      ],
                    },
                    line: 0,
                    links: {
                      hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786024_hd.jpg',
                      l: '',
                      m: '',
                      s: '',
                      xs: '',
                    },
                  },
                ],
              ],
            },
          },
        ],
        images: [
          {
            id: 786027,
            imageType: 'general',
            category: 127,
            description: {
              type: 'categoryLabel',
              categoryLabel: '',
              defects: [],
            },
            line: 0,
            links: {
              hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786027_hd.jpg',
              l: '',
              m: '',
              s: '',
              xs: '',
            },
          },
        ],
      },
      imagesExterior: {
        table: {
          tableHeadings: [
            '',
            'beschädigt',
            'Kratzer',
            'Delle',
            'Rost',
            'Nachlackierung',
            '',
          ],
          tableCells: [
            [
              'Dach',
              true,
              false,
              true,
              false,
              false,
              {
                id: 785976,
                imageType: 'defect',
                category: 1,
                description: {
                  type: 'defects',
                  categoryLabel: 'Dach',
                  defects: [
                    { id: 2, name: 'Beschadigt' },
                    { id: 3, name: 'Delle' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785976_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Motorhaube',
              false,
              true,
              false,
              true,
              false,
              {
                id: 785977,
                imageType: 'defect',
                category: 2,
                description: {
                  type: 'defects',
                  categoryLabel: 'Motorhaube',
                  defects: [
                    { id: 4, name: 'Kratzer' },
                    { id: 5, name: 'Rost' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785977_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Stoßfänger vorne links',
              false,
              true,
              false,
              true,
              false,
              {
                id: 785978,
                imageType: 'defect',
                category: 3,
                description: {
                  type: 'defects',
                  categoryLabel: 'Stoßfänger vorne links',
                  defects: [
                    { id: 4, name: 'Kratzer' },
                    { id: 5, name: 'Rost' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785978_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Kotflügel links',
              true,
              true,
              true,
              true,
              true,
              {
                id: 785979,
                imageType: 'defect',
                category: 4,
                description: {
                  type: 'defects',
                  categoryLabel: 'Kotflügel links',
                  defects: [
                    { id: 2, name: 'Beschadigt' },
                    { id: 3, name: 'Delle' },
                    { id: 4, name: 'Kratzer' },
                    { id: 5, name: 'Rost' },
                    { id: 6, name: 'Nachlackierung' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785979_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Außenspiegel links',
              false,
              true,
              false,
              false,
              false,
              {
                id: 785980,
                imageType: 'defect',
                category: 5,
                description: {
                  type: 'defects',
                  categoryLabel: 'Außenspiegel links',
                  defects: [{ id: 4, name: 'Kratzer' }],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785980_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            ['Tür vorne links', true, true, false, false, false, null],
            [
              'Tür vorne links',
              true,
              false,
              false,
              false,
              false,
              {
                id: 785981,
                imageType: 'defect',
                category: 6,
                description: {
                  type: 'defects',
                  categoryLabel: 'Tür vorne links',
                  defects: [{ id: 2, name: 'Beschadigt' }],
                },
                line: 1,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785981_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            ['Tür vorne links', false, true, true, false, true, null],
            [
              'Tür vorne links',
              false,
              false,
              false,
              false,
              false,
              {
                id: 785982,
                imageType: 'defect',
                category: 6,
                description: {
                  type: 'defects',
                  categoryLabel: 'Tür vorne links',
                  defects: [],
                },
                line: 3,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785982_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Türkantenanschlagspuren vorne links',
              false,
              false,
              true,
              false,
              true,
              null,
            ],
            [
              'Schweller links',
              true,
              false,
              false,
              false,
              false,
              {
                id: 785983,
                imageType: 'defect',
                category: 60,
                description: {
                  type: 'defects',
                  categoryLabel: 'Schweller links',
                  defects: [{ id: 2, name: 'Beschadigt' }],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785983_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            ['Tür hinten links', false, true, false, true, false, null],
            [
              'Türkantenanschlagspuren hinten links',
              true,
              false,
              false,
              false,
              true,
              null,
            ],
            [
              'Seitenteil hinten links',
              true,
              false,
              false,
              true,
              false,
              {
                id: 785984,
                imageType: 'defect',
                category: 8,
                description: {
                  type: 'defects',
                  categoryLabel: 'Seitenteil hinten links',
                  defects: [
                    { id: 2, name: 'Beschadigt' },
                    { id: 5, name: 'Rost' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785984_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            ['Stoßfänger hinten links', false, true, false, false, false, null],
            [
              'Heckklappe',
              false,
              false,
              true,
              true,
              false,
              {
                id: 785985,
                imageType: 'defect',
                category: 9,
                description: {
                  type: 'defects',
                  categoryLabel: 'Heckklappe',
                  defects: [
                    { id: 3, name: 'Delle' },
                    { id: 5, name: 'Rost' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785985_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Stoßfänger hinten Mitte',
              false,
              true,
              true,
              false,
              false,
              {
                id: 785986,
                imageType: 'defect',
                category: 44,
                description: {
                  type: 'defects',
                  categoryLabel: 'Stoßfänger hinten Mitte',
                  defects: [
                    { id: 3, name: 'Delle' },
                    { id: 4, name: 'Kratzer' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785986_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Stoßfänger hinten rechts',
              false,
              true,
              false,
              false,
              false,
              {
                id: 785987,
                imageType: 'defect',
                category: 46,
                description: {
                  type: 'defects',
                  categoryLabel: 'Stoßfänger hinten rechts',
                  defects: [{ id: 4, name: 'Kratzer' }],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785987_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Seitenteil hinten rechts',
              false,
              false,
              true,
              false,
              false,
              {
                id: 785988,
                imageType: 'defect',
                category: 11,
                description: {
                  type: 'defects',
                  categoryLabel: 'Seitenteil hinten rechts',
                  defects: [{ id: 3, name: 'Delle' }],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785988_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Tür hinten rechts',
              false,
              true,
              false,
              true,
              false,
              {
                id: 785989,
                imageType: 'defect',
                category: 12,
                description: {
                  type: 'defects',
                  categoryLabel: 'Tür hinten rechts',
                  defects: [
                    { id: 4, name: 'Kratzer' },
                    { id: 5, name: 'Rost' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785989_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Türkantenanschlagspuren hinten rechts',
              false,
              false,
              false,
              true,
              false,
              {
                id: 785990,
                imageType: 'defect',
                category: 62,
                description: {
                  type: 'defects',
                  categoryLabel: 'Türkantenanschlagspuren hinten rechts',
                  defects: [{ id: 5, name: 'Rost' }],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785990_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Schweller rechts',
              false,
              true,
              true,
              false,
              false,
              {
                id: 785991,
                imageType: 'defect',
                category: 63,
                description: {
                  type: 'defects',
                  categoryLabel: 'Schweller rechts',
                  defects: [
                    { id: 3, name: 'Delle' },
                    { id: 4, name: 'Kratzer' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785991_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Tür vorne rechts',
              false,
              false,
              true,
              false,
              false,
              {
                id: 785992,
                imageType: 'defect',
                category: 13,
                description: {
                  type: 'defects',
                  categoryLabel: 'Tür vorne rechts',
                  defects: [{ id: 3, name: 'Delle' }],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785992_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Türkantenanschlagspuren vorne rechts',
              false,
              false,
              true,
              true,
              false,
              {
                id: 785993,
                imageType: 'defect',
                category: 64,
                description: {
                  type: 'defects',
                  categoryLabel: 'Türkantenanschlagspuren vorne rechts',
                  defects: [
                    { id: 3, name: 'Delle' },
                    { id: 5, name: 'Rost' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785993_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Außenspiegel rechts',
              false,
              false,
              false,
              false,
              false,
              {
                id: 785994,
                imageType: 'defect',
                category: 14,
                description: {
                  type: 'defects',
                  categoryLabel: 'Außenspiegel rechts',
                  defects: [],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785994_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Kotflügel rechts',
              false,
              true,
              false,
              false,
              true,
              {
                id: 785995,
                imageType: 'defect',
                category: 15,
                description: {
                  type: 'defects',
                  categoryLabel: 'Kotflügel rechts',
                  defects: [
                    { id: 4, name: 'Kratzer' },
                    { id: 6, name: 'Nachlackierung' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785995_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Stoßfänger vorne rechts',
              false,
              false,
              true,
              true,
              false,
              {
                id: 785996,
                imageType: 'defect',
                category: 45,
                description: {
                  type: 'defects',
                  categoryLabel: 'Stoßfänger vorne rechts',
                  defects: [
                    { id: 3, name: 'Delle' },
                    { id: 5, name: 'Rost' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785996_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            ['Stoßfänger vorne rechts', false, true, true, false, false, null],
            ['Stoßfänger vorne rechts', false, true, false, false, false, null],
            [
              'Stoßfänger vorne Mitte',
              false,
              true,
              false,
              false,
              false,
              {
                id: 785997,
                imageType: 'defect',
                category: 65,
                description: {
                  type: 'defects',
                  categoryLabel: 'Stoßfänger vorne Mitte',
                  defects: [{ id: 4, name: 'Kratzer' }],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785997_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
          ],
        },
        images: [
          {
            id: 786013,
            imageType: 'general',
            category: 100,
            description: {
              type: 'dedicated',
              categoryLabel: 'Weitere Bilder Karosserie',
              dedicated: {
                de: 'Additional photos of the bodywork #VIEW100',
                en: 'Additional photos of the bodywork #VIEW100',
              },
              defects: [],
            },
            line: 0,
            links: {
              hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786013_hd.jpg',
              l: '',
              m: '',
              s: '',
              xs: '',
            },
          },
        ],
        list: [
          [
            'The vehicle was inspected during wet conditions; therefore additional surface defects may exist',
            'The vehicle was inspected during poor visibility; therefore additional surface defects may exist',
            'The vehicle has various scratches and defects on the surface',
            'Various repaints',
            'Scratches from car wash',
            'Exterior of vehicle dirty',
            'Engine compartment insulation damaged',
          ],
          [
            'Weitere Karosseriemange en Customer himself is important, he will be followed by the customer service. He needs the biggest recipe. No matter how soft you are, there is no laoreet, nor a gate. Mauris and members of the tortor. There is no medical malpractice, just an airline operator. Proin tincidunt Euismod ligula and tincidunt. Aenean that is free from rhoncus tincidunt. \n\nAs the employee hates',
          ],
        ],
      },
      imagesInterior: {
        table: {
          tableHeadings: [
            '',
            'Verschleiß',
            'beschädigt',
            'Brandloch',
            'Flecken',
            '',
          ],
          tableCells: [
            [
              'Fahrersitz',
              false,
              true,
              false,
              true,
              {
                id: 785998,
                imageType: 'defect',
                category: 17,
                description: {
                  type: 'defects',
                  categoryLabel: 'Fahrersitz',
                  defects: [
                    { id: 2, name: 'Beschadigt' },
                    { id: 21, name: 'Flecken' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785998_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Beifahrersitz',
              true,
              false,
              false,
              false,
              {
                id: 785999,
                imageType: 'defect',
                category: 18,
                description: {
                  type: 'defects',
                  categoryLabel: 'Beifahrersitz',
                  defects: [{ id: 23, name: 'Verschleiss' }],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785999_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Rückbank',
              true,
              false,
              false,
              true,
              {
                id: 786000,
                imageType: 'defect',
                category: 19,
                description: {
                  type: 'defects',
                  categoryLabel: 'Rückbank',
                  defects: [
                    { id: 21, name: 'Flecken' },
                    { id: 23, name: 'Verschleiss' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786000_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Teppichboden',
              true,
              false,
              false,
              true,
              {
                id: 786001,
                imageType: 'defect',
                category: 20,
                description: {
                  type: 'defects',
                  categoryLabel: 'Teppichboden',
                  defects: [
                    { id: 21, name: 'Flecken' },
                    { id: 23, name: 'Verschleiss' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786001_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Himmel',
              false,
              true,
              false,
              true,
              {
                id: 786002,
                imageType: 'defect',
                category: 21,
                description: {
                  type: 'defects',
                  categoryLabel: 'Himmel',
                  defects: [
                    { id: 2, name: 'Beschadigt' },
                    { id: 21, name: 'Flecken' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786002_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Armaturenbrett',
              true,
              true,
              false,
              false,
              {
                id: 786003,
                imageType: 'defect',
                category: 22,
                description: {
                  type: 'defects',
                  categoryLabel: 'Armaturenbrett',
                  defects: [
                    { id: 2, name: 'Beschadigt' },
                    { id: 23, name: 'Verschleiss' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786003_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Lenkrad',
              false,
              true,
              true,
              false,
              {
                id: 786004,
                imageType: 'defect',
                category: 66,
                description: {
                  type: 'defects',
                  categoryLabel: 'Lenkrad',
                  defects: [
                    { id: 2, name: 'Beschadigt' },
                    { id: 22, name: 'Brandloch' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786004_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Schaltmanschette',
              true,
              false,
              false,
              false,
              {
                id: 786005,
                imageType: 'defect',
                category: 67,
                description: {
                  type: 'defects',
                  categoryLabel: 'Schaltmanschette',
                  defects: [{ id: 23, name: 'Verschleiss' }],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786005_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Türverkleidung vorne links',
              true,
              false,
              false,
              false,
              {
                id: 786006,
                imageType: 'defect',
                category: 23,
                description: {
                  type: 'defects',
                  categoryLabel: 'Türverkleidung vorne links',
                  defects: [{ id: 23, name: 'Verschleiss' }],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786006_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Türverkleidung hinten links',
              true,
              false,
              false,
              true,
              {
                id: 786007,
                imageType: 'defect',
                category: 97,
                description: {
                  type: 'defects',
                  categoryLabel: 'Türverkleidung hinten links',
                  defects: [
                    { id: 21, name: 'Flecken' },
                    { id: 23, name: 'Verschleiss' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786007_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Türverkleidung hinten rechts',
              false,
              false,
              false,
              true,
              {
                id: 786008,
                imageType: 'defect',
                category: 98,
                description: {
                  type: 'defects',
                  categoryLabel: 'Türverkleidung hinten rechts',
                  defects: [{ id: 21, name: 'Flecken' }],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786008_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Türverkleidung vorne rechts',
              false,
              true,
              false,
              true,
              {
                id: 786009,
                imageType: 'defect',
                category: 24,
                description: {
                  type: 'defects',
                  categoryLabel: 'Türverkleidung vorne rechts',
                  defects: [
                    { id: 2, name: 'Beschadigt' },
                    { id: 21, name: 'Flecken' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786009_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Seitenverkleidung links',
              false,
              true,
              false,
              false,
              {
                id: 786010,
                imageType: 'defect',
                category: 99,
                description: {
                  type: 'defects',
                  categoryLabel: 'Seitenverkleidung links',
                  defects: [{ id: 2, name: 'Beschadigt' }],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786010_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Seitenverkleidung rechts',
              false,
              false,
              false,
              true,
              {
                id: 786011,
                imageType: 'defect',
                category: 100,
                description: {
                  type: 'defects',
                  categoryLabel: 'Seitenverkleidung rechts',
                  defects: [{ id: 21, name: 'Flecken' }],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786011_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            [
              'Laderaum',
              true,
              false,
              false,
              true,
              {
                id: 786012,
                imageType: 'defect',
                category: 47,
                description: {
                  type: 'defects',
                  categoryLabel: 'Laderaum',
                  defects: [
                    { id: 21, name: 'Flecken' },
                    { id: 23, name: 'Verschleiss' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786012_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
          ],
        },
        images: [
          {
            id: 786014,
            imageType: 'general',
            category: 101,
            description: {
              type: 'dedicated',
              categoryLabel: 'Weitere Bilder Innenraum',
              dedicated: {
                de: 'Additional photos of the interior #VIEW101',
                en: 'Additional photos of the interior #VIEW101',
              },
              defects: [],
            },
            line: 0,
            links: {
              hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786014_hd.jpg',
              l: '',
              m: '',
              s: '',
              xs: '',
            },
          },
        ],
        list: [
          [
            'Traces of use',
            'Dirty',
            'Smoker\'s vehicle',
            'Vehicle was used to transport dogs',
            'Soft-touch paint is peeling',
            'Gear shift knob is worn',
            'Unpleasant odour',
          ],
          [
            'Weitere Innerraummangel en The customer is very important, the customer will be followed by the customer. He needs the biggest recipe. No matter how soft you are, there is no laoreet, nor a gate. Mauris and members of the tortor. There is no medical malpractice, just an airline operator. Proin tincidunt Euismod ligula and tincidunt. Aenean that free from the rhoncus tincidunt.\n\n As the employee hates',
          ],
        ],
      },
      imagesWindshield: {
        table: {
          tableHeadings: [
            '',
            'beschädigt',
            'kleine Steinschläge',
            'grosse Steinschlage ',
            'Riss',
            'Austausch empfohlen',
            '',
          ],
          tableCells: [
            ['Windschutzscheibe', true, false, true, false, true, null],
            ['Scheinwerfer links', false, false, false, true, false, null],
            ['Nebelscheinwerfer links', false, true, false, false, true, null],
            ['Nebelscheinwerfer rechts', false, false, false, true, false, null],
            ['Scheinwerfer rechts', false, true, false, true, false, null],
            ['Motorhaube', false, false, true, false, false, null],
            [
              'Stoßfänger vorne',
              true,
              true,
              true,
              false,
              false,
              {
                id: 786025,
                imageType: 'defect',
                category: 10,
                description: {
                  type: 'defects',
                  categoryLabel: 'Stoßfänger vorne',
                  defects: [
                    { id: 10, name: 'Beschadigt' },
                    { id: 11, name: 'Kleine Steinschlage' },
                    { id: 12, name: 'grosse Steinschlage ' },
                  ],
                },
                line: 0,
                links: {
                  hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786025_hd.jpg',
                  l: '',
                  m: '',
                  s: '',
                  xs: '',
                },
              },
            ],
            ['Frontbereich allgemein', false, true, false, false, false, null],
          ],
        },
        images: [],
        list: [
          [],
          [
            'Sonstige erkannte Glasschaden en Sonstige erkanntte Glasschaden de Lorem prèsme prèsme sempermomente, consecuture adipiscing elit. He needs the biggest recipe. No matter how soft you are, there is no laoreet, nor a gate. Mauris and members of the tortor. There is no medical malpractice, just an airline operator. Proin tincidunt Euismod ligula and tincidunt. \n\nAenean that is free from rhoncus tincidunt. \n\nAs the employee hates',
          ],
        ],
      },
      foundDefects: {
        tableCells: [
          [
            '',
            [
              'Fahrzeug bedingt fahrbereit! Fahrzeug sollte mit einem entsprechenden Transporter abgeholt werden! Eigenständige Verladung muss gewährleistet werden!',
            ],
          ],
          [
            'Motor',
            [
              'Ölverlust',
              'ruckelt',
              'stottert',
              'klackert',
              'Motorschaden',
              'Zylinderkopfdichtung defekt',
              'qualmt',
              'Turbolader-Schaden',
              'Geräusche - Diagnose erforderlich',
            ],
          ],
          [
            'Getriebe',
            [
              'rasselt',
              'schwergängig',
              'Getriebeschaden',
              'Geräusche - Diagnose erforderlich',
              'Automatik: keine Kraftübertragung',
            ],
          ],
          ['Kupplung', ['schwergängig']],
          [
            'Abgasanlage',
            [
              'undicht (laut)',
              'verrostet',
              'teilweise erneuerungsbedürftig',
              'vollständig erneuerungsbedürftig',
              'Katalysator defekt',
            ],
          ],
          [
            'Bremsanlage',
            [
              'Bremsen vorne Verschleiß',
              'Bremsen hinten Verschleiß',
              'nicht verkehrssicher',
            ],
          ],
          [
            'Innenraum',
            ['Klima ohne Funktion', 'Klimaanlage konnte nicht geprüft werden'],
          ],
          [
            'Elektrische Anlage',
            [
              'Batterie tiefentladen. Es konnte keine Funktionsprüfung der mit notwendigem Motorlauf verbundenen Eigenschaften erfolgen. (U.a. Motor, Anzeigen, elektrische Funktionen, etc.)',
            ],
          ],
          ['Weitere technische Mängel', ['lorem ipsum dolor sit amet']],
        ],
      },
      missingParts: [
        [
          'CD-Wechsler-Magazin',
          'Gepäckraumtrennetz',
          'Reserverad / Pannenset',
          'Laderaumabdeckung',
          'Navi-CD/DVD: fehlt',
          'Radio-Code',
          'Antenne',
          'Kugelkopf (für Anhängerkupplung)',
          'Scheckheft',
          'lorem ipsum dolor sit amet',
        ],
        [
          'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsa fugit harum, necessitatibus corporis quis atque nisi hic quam in fugiat quas modi obcaecati eligendi animi laudantium labore voluptate libero amet.Fugit itaque nisi reiciendis error cumque laudantium recusandae voluptatibus vitae rerum facilis veritatis iure sapiente, nam rem labore quia deleniti eveniet non harum eius. Voluptate quidem odit molestiae modi excepturi!',
        ],
      ],
      gallery: [
        {
          id: 787036,
          imageType: 'general',
          category: 1,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht vorne links',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/787036_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 787037,
          imageType: 'general',
          category: 2,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht vorne rechts',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/787037_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 787038,
          imageType: 'general',
          category: 3,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht hinten links',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/787038_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 787039,
          imageType: 'general',
          category: 4,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht hinten rechts',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/787039_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785947,
          imageType: 'general',
          category: 5,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Innenraum',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785947_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785949,
          imageType: 'general',
          category: 7,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Kombiinstrument',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785949_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785950,
          imageType: 'general',
          category: 117,
          description: {
            type: 'categoryLabel',
            categoryLabel: '2ter Radsatz',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785950_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785951,
          imageType: 'general',
          category: 117,
          description: {
            type: 'categoryLabel',
            categoryLabel: '2ter Radsatz',
            defects: [],
          },
          line: 1,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785951_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785952,
          imageType: 'general',
          category: 102,
          description: {
            type: 'dedicated',
            categoryLabel: 'Zusatzbild',
            dedicated: { de: 'Übertragung', en: 'transmission' },
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785952_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785953,
          imageType: 'general',
          category: 102,
          description: {
            type: 'dedicated',
            categoryLabel: 'Zusatzbild',
            dedicated: { de: 'Stamm', en: 'tribe' },
            defects: [],
          },
          line: 1,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785953_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785956,
          imageType: 'general',
          category: 200,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Front',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785956_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785957,
          imageType: 'general',
          category: 201,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Heck',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785957_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785958,
          imageType: 'general',
          category: 202,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Kofferraum / Laderaum',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785958_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785959,
          imageType: 'general',
          category: 208,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Scheinwerfer links',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785959_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785960,
          imageType: 'general',
          category: 213,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Lenkrad',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785960_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785961,
          imageType: 'general',
          category: 214,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Mittelkonsole',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785961_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785962,
          imageType: 'general',
          category: 214,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Mittelkonsole',
            defects: [],
          },
          line: 1,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785962_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785963,
          imageType: 'general',
          category: 215,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Navigation',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785963_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785964,
          imageType: 'general',
          category: 216,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Weitere Sonderausstattung',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785964_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785965,
          imageType: 'general',
          category: 217,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Sitze vorne',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785965_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785966,
          imageType: 'general',
          category: 218,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Bedienknöpfe eSitze',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785966_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785967,
          imageType: 'general',
          category: 226,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Soundsystem',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785967_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785968,
          imageType: 'general',
          category: 227,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Rückbank',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785968_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785969,
          imageType: 'general',
          category: 228,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Bedienknöpfe eSitze hinten',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785969_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785970,
          imageType: 'general',
          category: 219,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Klimaautomatik Fond',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785970_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785971,
          imageType: 'general',
          category: 220,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Fondentertainment und Zubehör',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785971_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785972,
          imageType: 'general',
          category: 221,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht 3. Sitzreihe',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785972_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785973,
          imageType: 'general',
          category: 222,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht LPG Umbau',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785973_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785974,
          imageType: 'general',
          category: 223,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Elektrofahrzeug',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785974_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785975,
          imageType: 'general',
          category: 224,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Ansicht Windschott',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785975_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785954,
          imageType: 'general',
          category: 103,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Detailfoto',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785954_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785955,
          imageType: 'general',
          category: 103,
          description: {
            type: 'categoryLabel',
            categoryLabel: 'Detailfoto',
            defects: [],
          },
          line: 1,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785955_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786026,
          imageType: 'general',
          category: 128,
          description: {
            type: 'categoryLabel',
            categoryLabel: '',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786026_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786027,
          imageType: 'general',
          category: 127,
          description: {
            type: 'categoryLabel',
            categoryLabel: '',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786027_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786013,
          imageType: 'general',
          category: 100,
          description: {
            type: 'dedicated',
            categoryLabel: 'Weitere Bilder Karosserie',
            dedicated: {
              de: 'Additional photos of the bodywork #VIEW100',
              en: 'Additional photos of the bodywork #VIEW100',
            },
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786013_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786014,
          imageType: 'general',
          category: 101,
          description: {
            type: 'dedicated',
            categoryLabel: 'Weitere Bilder Innenraum',
            dedicated: {
              de: 'Additional photos of the interior #VIEW101',
              en: 'Additional photos of the interior #VIEW101',
            },
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786014_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785976,
          imageType: 'defect',
          category: 1,
          description: {
            type: 'defects',
            categoryLabel: 'Dach',
            defects: [
              { id: 2, name: 'Beschadigt' },
              { id: 3, name: 'Delle' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785976_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785977,
          imageType: 'defect',
          category: 2,
          description: {
            type: 'defects',
            categoryLabel: 'Motorhaube',
            defects: [
              { id: 4, name: 'Kratzer' },
              { id: 5, name: 'Rost' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785977_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785978,
          imageType: 'defect',
          category: 3,
          description: {
            type: 'defects',
            categoryLabel: 'Stoßfänger vorne links',
            defects: [
              { id: 4, name: 'Kratzer' },
              { id: 5, name: 'Rost' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785978_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785979,
          imageType: 'defect',
          category: 4,
          description: {
            type: 'defects',
            categoryLabel: 'Kotflügel links',
            defects: [
              { id: 2, name: 'Beschadigt' },
              { id: 3, name: 'Delle' },
              { id: 4, name: 'Kratzer' },
              { id: 5, name: 'Rost' },
              { id: 6, name: 'Nachlackierung' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785979_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785980,
          imageType: 'defect',
          category: 5,
          description: {
            type: 'defects',
            categoryLabel: 'Außenspiegel links',
            defects: [{ id: 4, name: 'Kratzer' }],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785980_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785981,
          imageType: 'defect',
          category: 6,
          description: {
            type: 'defects',
            categoryLabel: 'Tür vorne links',
            defects: [{ id: 2, name: 'Beschadigt' }],
          },
          line: 1,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785981_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785982,
          imageType: 'defect',
          category: 6,
          description: {
            type: 'defects',
            categoryLabel: 'Tür vorne links',
            defects: [],
          },
          line: 3,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785982_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785983,
          imageType: 'defect',
          category: 60,
          description: {
            type: 'defects',
            categoryLabel: 'Schweller links',
            defects: [{ id: 2, name: 'Beschadigt' }],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785983_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785984,
          imageType: 'defect',
          category: 8,
          description: {
            type: 'defects',
            categoryLabel: 'Seitenteil hinten links',
            defects: [
              { id: 2, name: 'Beschadigt' },
              { id: 5, name: 'Rost' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785984_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785985,
          imageType: 'defect',
          category: 9,
          description: {
            type: 'defects',
            categoryLabel: 'Heckklappe',
            defects: [
              { id: 3, name: 'Delle' },
              { id: 5, name: 'Rost' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785985_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785986,
          imageType: 'defect',
          category: 44,
          description: {
            type: 'defects',
            categoryLabel: 'Stoßfänger hinten Mitte',
            defects: [
              { id: 3, name: 'Delle' },
              { id: 4, name: 'Kratzer' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785986_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785987,
          imageType: 'defect',
          category: 46,
          description: {
            type: 'defects',
            categoryLabel: 'Stoßfänger hinten rechts',
            defects: [{ id: 4, name: 'Kratzer' }],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785987_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785988,
          imageType: 'defect',
          category: 11,
          description: {
            type: 'defects',
            categoryLabel: 'Seitenteil hinten rechts',
            defects: [{ id: 3, name: 'Delle' }],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785988_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785989,
          imageType: 'defect',
          category: 12,
          description: {
            type: 'defects',
            categoryLabel: 'Tür hinten rechts',
            defects: [
              { id: 4, name: 'Kratzer' },
              { id: 5, name: 'Rost' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785989_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785990,
          imageType: 'defect',
          category: 62,
          description: {
            type: 'defects',
            categoryLabel: 'Türkantenanschlagspuren hinten rechts',
            defects: [{ id: 5, name: 'Rost' }],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785990_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785991,
          imageType: 'defect',
          category: 63,
          description: {
            type: 'defects',
            categoryLabel: 'Schweller rechts',
            defects: [
              { id: 3, name: 'Delle' },
              { id: 4, name: 'Kratzer' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785991_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785992,
          imageType: 'defect',
          category: 13,
          description: {
            type: 'defects',
            categoryLabel: 'Tür vorne rechts',
            defects: [{ id: 3, name: 'Delle' }],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785992_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785993,
          imageType: 'defect',
          category: 64,
          description: {
            type: 'defects',
            categoryLabel: 'Türkantenanschlagspuren vorne rechts',
            defects: [
              { id: 3, name: 'Delle' },
              { id: 5, name: 'Rost' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785993_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785994,
          imageType: 'defect',
          category: 14,
          description: {
            type: 'defects',
            categoryLabel: 'Außenspiegel rechts',
            defects: [],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785994_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785995,
          imageType: 'defect',
          category: 15,
          description: {
            type: 'defects',
            categoryLabel: 'Kotflügel rechts',
            defects: [
              { id: 4, name: 'Kratzer' },
              { id: 6, name: 'Nachlackierung' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785995_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785996,
          imageType: 'defect',
          category: 45,
          description: {
            type: 'defects',
            categoryLabel: 'Stoßfänger vorne rechts',
            defects: [
              { id: 3, name: 'Delle' },
              { id: 5, name: 'Rost' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785996_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785997,
          imageType: 'defect',
          category: 65,
          description: {
            type: 'defects',
            categoryLabel: 'Stoßfänger vorne Mitte',
            defects: [{ id: 4, name: 'Kratzer' }],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785997_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785998,
          imageType: 'defect',
          category: 17,
          description: {
            type: 'defects',
            categoryLabel: 'Fahrersitz',
            defects: [
              { id: 2, name: 'Beschadigt' },
              { id: 21, name: 'Flecken' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785998_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 785999,
          imageType: 'defect',
          category: 18,
          description: {
            type: 'defects',
            categoryLabel: 'Beifahrersitz',
            defects: [{ id: 23, name: 'Verschleiss' }],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/785999_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786000,
          imageType: 'defect',
          category: 19,
          description: {
            type: 'defects',
            categoryLabel: 'Rückbank',
            defects: [
              { id: 21, name: 'Flecken' },
              { id: 23, name: 'Verschleiss' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786000_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786001,
          imageType: 'defect',
          category: 20,
          description: {
            type: 'defects',
            categoryLabel: 'Teppichboden',
            defects: [
              { id: 21, name: 'Flecken' },
              { id: 23, name: 'Verschleiss' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786001_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786002,
          imageType: 'defect',
          category: 21,
          description: {
            type: 'defects',
            categoryLabel: 'Himmel',
            defects: [
              { id: 2, name: 'Beschadigt' },
              { id: 21, name: 'Flecken' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786002_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786003,
          imageType: 'defect',
          category: 22,
          description: {
            type: 'defects',
            categoryLabel: 'Armaturenbrett',
            defects: [
              { id: 2, name: 'Beschadigt' },
              { id: 23, name: 'Verschleiss' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786003_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786004,
          imageType: 'defect',
          category: 66,
          description: {
            type: 'defects',
            categoryLabel: 'Lenkrad',
            defects: [
              { id: 2, name: 'Beschadigt' },
              { id: 22, name: 'Brandloch' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786004_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786005,
          imageType: 'defect',
          category: 67,
          description: {
            type: 'defects',
            categoryLabel: 'Schaltmanschette',
            defects: [{ id: 23, name: 'Verschleiss' }],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786005_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786006,
          imageType: 'defect',
          category: 23,
          description: {
            type: 'defects',
            categoryLabel: 'Türverkleidung vorne links',
            defects: [{ id: 23, name: 'Verschleiss' }],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786006_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786007,
          imageType: 'defect',
          category: 97,
          description: {
            type: 'defects',
            categoryLabel: 'Türverkleidung hinten links',
            defects: [
              { id: 21, name: 'Flecken' },
              { id: 23, name: 'Verschleiss' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786007_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786008,
          imageType: 'defect',
          category: 98,
          description: {
            type: 'defects',
            categoryLabel: 'Türverkleidung hinten rechts',
            defects: [{ id: 21, name: 'Flecken' }],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786008_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786009,
          imageType: 'defect',
          category: 24,
          description: {
            type: 'defects',
            categoryLabel: 'Türverkleidung vorne rechts',
            defects: [
              { id: 2, name: 'Beschadigt' },
              { id: 21, name: 'Flecken' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786009_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786010,
          imageType: 'defect',
          category: 99,
          description: {
            type: 'defects',
            categoryLabel: 'Seitenverkleidung links',
            defects: [{ id: 2, name: 'Beschadigt' }],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786010_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786011,
          imageType: 'defect',
          category: 100,
          description: {
            type: 'defects',
            categoryLabel: 'Seitenverkleidung rechts',
            defects: [{ id: 21, name: 'Flecken' }],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786011_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786012,
          imageType: 'defect',
          category: 47,
          description: {
            type: 'defects',
            categoryLabel: 'Laderaum',
            defects: [
              { id: 21, name: 'Flecken' },
              { id: 23, name: 'Verschleiss' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786012_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786015,
          imageType: 'defect',
          category: 28,
          description: {
            type: 'defects',
            categoryLabel: 'vorne links',
            defects: [
              { id: 10, name: 'Beschadigt' },
              { id: 17, name: 'Gerissen' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786015_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786017,
          imageType: 'defect',
          category: 26,
          description: {
            type: 'defects',
            categoryLabel: 'hinten links',
            defects: [
              { id: 4, name: 'Kratzer' },
              { id: 18, name: 'Ohne Luft' },
            ],
          },
          line: 1,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786017_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786016,
          imageType: 'defect',
          category: 26,
          description: {
            type: 'defects',
            categoryLabel: 'hinten links',
            defects: [{ id: 17, name: 'Gerissen' }],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786016_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786018,
          imageType: 'defect',
          category: 26,
          description: {
            type: 'defects',
            categoryLabel: 'hinten links',
            defects: [{ id: 17, name: 'Gerissen' }],
          },
          line: 2,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786018_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786019,
          imageType: 'defect',
          category: 27,
          description: {
            type: 'defects',
            categoryLabel: 'hinten rechts',
            defects: [
              { id: 16, name: 'Poros' },
              { id: 18, name: 'Ohne Luft' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786019_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786020,
          imageType: 'defect',
          category: 29,
          description: {
            type: 'defects',
            categoryLabel: 'vorne rechts',
            defects: [
              { id: 4, name: 'Kratzer' },
              { id: 10, name: 'Beschadigt' },
              { id: 16, name: 'Poros' },
              { id: 17, name: 'Gerissen' },
              { id: 18, name: 'Ohne Luft' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786020_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786021,
          imageType: 'defect',
          category: 29,
          description: {
            type: 'defects',
            categoryLabel: 'vorne rechts',
            defects: [],
          },
          line: 1,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786021_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786025,
          imageType: 'defect',
          category: 10,
          description: {
            type: 'defects',
            categoryLabel: 'Stoßfänger vorne',
            defects: [
              { id: 10, name: 'Beschadigt' },
              { id: 11, name: 'Kleine Steinschlage' },
              { id: 12, name: 'grosse Steinschlage ' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786025_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786022,
          imageType: 'defect',
          category: 70,
          description: {
            type: 'defects',
            categoryLabel: 'vorne links',
            defects: [{ id: 18, name: 'Ohne Luft' }],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786022_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786023,
          imageType: 'defect',
          category: 69,
          description: {
            type: 'defects',
            categoryLabel: 'hinten rechts',
            defects: [
              { id: 4, name: 'Kratzer' },
              { id: 16, name: 'Poros' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786023_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
        {
          id: 786024,
          imageType: 'defect',
          category: 71,
          description: {
            type: 'defects',
            categoryLabel: 'vorne rechts',
            defects: [
              { id: 10, name: 'Beschadigt' },
              { id: 18, name: 'Ohne Luft' },
            ],
          },
          line: 0,
          links: {
            hd: 'https://cdn.t2.amab.dev/data/cars/5654/565306/786024_hd.jpg',
            l: '',
            m: '',
            s: '',
            xs: '',
          },
        },
      ],
      accidentPredamages: [
        [
          'Bestehender Schaden',
          [
            '0 ALLE EINSTIEGSLEISTEN, FLECKEN, GEBRAUCHSSPUR 0.0\r\n1 DACHAUSSENHAUT, DELLE, KALT RÜCKFORMEN 58.8\r\n2 DACHAUSSENHAUT, FLECKEN, POLIEREN 88.2\r\n3 MINDERWERT LENKRAD, KRATZER, SMART REPAIR 98.0\r\n4 FOTO GEPÄCKRAUM, SERVICEARBEITEN, SERVICEWERKSTATT 0.0 \r\n5 FOTO BEIPACKTASCHE, SERVICEARBEITEN, SERVICEWERKSTATT 0.0\r\n6 FOTO DISPLAY MIT LAUFLEISTUNG, SERVICEARBEITEN, SERVICEWERKSTATT 0.0\r\n7 HECKKLAPPE, KRATZER, POLIEREN 29.4\r\n8 SCHEIBENRAD ALU V R, KRATZER, GEBRAUCHSSPUR 0.0\r\n9 VERKLEIDUNG STOSSF H, DELLE, ERSETZEN MIT LACKIEREN 1090.26\r\n10 SCHEIBENRAD ALU V L, KRATZER, ERSETZEN 369.29\r\n11 VERKLEIDUNG A-BLECH, KRATZER, ERSETZEN 149.25\r\n12 VERKLEIDUNG U HECKKL, KRATZER, GEBRAUCHSSPUR 0.0\r\n13 HECKSPOILER, KRATZER, LACKIEREN 155.3\r\n14 SONSTIGES, KRATZER, ERSETZEN 58.88\r\n15 RUECKWAND V R, KRATZER, ERSETZEN 115.71\r\n16 ABZÜG DURCH VERBUNDARBEITEN, ,  -19.6\r\n17 SITZBEZUG V R, FLECKEN, GEBRAUCHSSPUR 0.0\r\n18 HAUPTARBEIT, SONSTIGES, SERVICEWERKSTATT 19.6\r\n19 BLENDE EINSTIEG V R, KRATZER, ERSETZEN 54.49\r\n20 HAUPTARBEIT, SONSTIGES, LACK 186.2\r\n21 AUSSENSPIEGEL L, STEINSCHLAG, GEBRAUCHSSPUR 0.0\r\n22 TUER V L, KRATZER, AUSLEGEN 29.4\r\n23 ALLE TÜRVERKLEIDUNGEN, FLECKEN, GEBRAUCHSSPUR 0.0\r\n24 BLENDE MITTELKONSOLE, KRATZER, GEBRAUCHSSPUR 0.0\r\n25 SEITENWAND H R, KRATZER, AUSLEGEN 29.4\r\n26 FUSSMATTEN KOMPLETT, FLECKEN, GEBRAUCHSSPUR 0.0\r\n27 TUER H R, KRATZER, AUSLEGEN 58.8\r\n28 LEDERPFLEGE KLEIN, FLECKEN, REINIGEN 49.0\r\n29 TUER H R, DELLE, KALT RÜCKFORMEN 58.8\r\n30 LEHNENBEZUG V L, FLECKEN, GEBRAUCHSSPUR 0.0\r\n31 AUSSENSPIEGEL R, STEINSCHLAG, GEBRAUCHSSPUR 0.0\r\n32 SITZBEZUG V L, FLECKEN, GEBRAUCHSSPUR 0.0\r\n33 SEITENWAND V R, KRATZER, POLIEREN 29.4\r\n34 C-SÄULE LINKS, DELLE, GEBRAUCHSSPUR 0.0\r\n35 VERKLEIDUNG STOSSF V, STEINSCHLAG, LACKIEREN 459.88\r\n36 EINSTIEG INNEN HINTEN LINKS AUSLEGEN, KRATZER, AUSLEGEN 29.4\r\n37 FRONTKLAPPE, STEINSCHLAG, AUSLEGEN 29.4\r\n38 RUECKWAND V L, KRATZER, GEBRAUCHSSPUR 0.0\r\n39 FRONTSCHEIBE GET, STEINSCHLAG, GEBRAUCHSSPUR 0.0\r\n40 DACHRELING L, KRATZER, AUSLEGEN 29.4',
            'Schadenshöhe 1000.00 Netto',
            {
              type: 'redSpan',
              value: 'Lorem ipsum dolor sit amet',
            },
          ],
        ],
        [
          'Reparierter Vorschaden',
          [
            'Anzahl 3',
            'Schadenshöhe ca. 1000.00 Netto',
            'Reparaturrechnung(en) liegen vor',
          ],
        ],
      ],
      goft: { headline: 'Goft information', text: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Commodi amet error, perferendis consequuntur quos id incidunt libero' },
      generalInformation: [
        [
          'Kamera pro couvání',
          'Klimatizace',
        ],
        ['Anti-lock Braking System, rearview camera, air conditioning, Apple Carplay/Android Auto, Anti-slip regulation, Brake Assist System, driver airbag, Bluetooth, on-board computer, body-colored exterior mirrors, central locking with remote control, automatic low beam, electronic brake force distribution, electric rear windows, electric windows for, Electronic Stability Program, hill hold function, rear head airbag(s), head airbag(s) for, rear seat can be folded down in parts, MP3 player, multimedia preparation, passenger airbag, radio, start/stop system, alarm class 1 (immobilizer), height-adjustable driver\'s seat, multifunction steering wheel, adjustable handlebars, power steering, side airbag(s) for'],
      ],
      startPrice: [
        ['Ausrufpreis', '1500 €'],
        ['Steuer', 'Mwst. ausweisbar'],
      ],
      engineTransmissionTurbo: [
        ['Austauschmotor verbaut. Nachweis vorhanden'],
        ['Motortausch bei:', '10000 Kilometer'],
        ['Gebrauchtgetriebe verbaut. Nachweis vorhanden'],
        ['Getriebetausch bei:', '1000 Kilometer'],
        ['Laufleistung des Gebrauchtgetriebes: ca.', '9000 Kilometer'],
        ['Austauschturbo verbaut. Nachweis nicht vorhanden'],
        ['Turbo getauscht bei', '10000 Kilometer'],
      ],
      accidentInfo: true,
      manufacturerInformation: {
        name: 'Autobid',
        street: 'example',
        city: 'example',
        zipCode: '00-000',
        country: 'Germany',
        website: 'https://autobid.de',
        email: 'contact@autobid.de',
      },
    },
  },
  metadata: {
    previous: null,
    next: null,
    lastCatalogNumber: 1,
    total: 1,
  },
}
